<template>
  <v-app class="bgLightGreen" id="inspire">
    <Header back header-text="lng_payment_plans_title"></Header>
    <v-container fluid fill-height>
      <v-flex>
        <h2 class="headline headingColor--text font-weight-bold text-xs-center">
          {{ "lng_select_plan_text" | translate }}
        </h2>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12 pa-3 login-block">
              <v-card-text>
                <v-layout column align-center justify-center>
                  <p>
                    <span class="display-1 text--primary">
                      228 DKK
                    </span>
                    <span>incl. VAT</span>
                  </p>
                  <p>12 {{ "lng_month_text" | translate }}</p>
                  <p>{{ showExpiryDate }}</p>
                  <v-btn
                    color="primary"
                    :loading="showLoading"
                    @click="openPaymentPage"
                    >{{ "lng_select_plan_btn_text" | translate }}</v-btn
                  >
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
    <payment-response-modal
      :open-dialog="responseModalToggle"
      :close-dialog="closeResponseModal"
      :go-to-button="redirectButton"
      :type-success="successStatus"
      :message-title="paymentResponseTitle"
      :message-text="paymentResponseMsg"
      ok-button-text="lng_redirect_home_btn_text"
    />
  </v-app>
</template>
<script>
import Header from "../components/Header";
import { mapGetters } from "vuex";
import GlobalService from "../services/global-service";
import moment from "moment";
import PaymentResponseModal from "../components/PaymentResponseModal";
import router from "../router.js";

export default {
  name: "PaymentPlans",
  components: {
    Header,
    PaymentResponseModal
  },
  data: () => ({
    expiryDate: undefined,
    showLoading: false,
    responseModalToggle: false,
    successStatus: true,
    paymentResponseTitle: "",
    paymentResponseMsg: ""
  }),
  created() {
    this.expiryDate = localStorage.getItem("expirydate");
  },
  mounted() {
    if (this.$route.query.orderid && this.$route.query.orderid === "cancel") {
      this.paymentResponseTitle = "lng_payment_response_fail_title";
      this.paymentResponseMsg = "lng_payment_response_fail_text";
      this.successStatus = false;
      this.responseModalToggle = true;
    } else if (this.$route.query.orderid) {
      this.paymentResponseTitle = "lng_payment_response_success_title";
      this.paymentResponseMsg = "lng_payment_response_success_text";
      this.successStatus = true;
      this.responseModalToggle = true;
    }
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    showExpiryDate() {
      if (this.expiryDate) {
        let currentDate = moment.utc(new Date()).format("DD-MM-YYYY");
        let formatedExpiryDate = moment
          .utc(this.expiryDate)
          .format("DD-MM-YYYY");
        if (formatedExpiryDate < currentDate) {
          // console.log('dddddd: ', formatedExpiryDate, currentDate, moment(formatedExpiryDate, "DD-MM-YYYY").add('years', 1).format('DD-MM-YYYY'));
          return moment(formatedExpiryDate, "DD-MM-YYYY")
            .add(1, "years")
            .format("DD MMMM YYYY");
        } else {
          return moment(currentDate, "DD-MM-YYYY")
            .add(1, "years")
            .format("DD MMMM YYYY");
        }
      }
      return null;
    }
  },
  methods: {
    async openPaymentPage() {
      this.showLoading = true;
      let data = await GlobalService.getPaymentLink(
        12,
        "uk",
        this.getUser.token
      );
      location.href = data.link;
      this.showLoading = false;
    },
    closeResponseModal() {
      this.responseModalToggle = false;
    },
    redirectButton() {
      router.push("/");
    }
  }
};
</script>
